
import { defineComponent } from 'vue'
import { iMail } from '../../DocumentExecution'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import Dialog from 'primevue/dialog'
import Editor from 'primevue/editor'
import documentExecutionMailDialogDescriptor from './DocumentExecutionMailDialogDescriptor.json'
import Message from 'primevue/message'

export default defineComponent({
    name: 'document-execution-help-dialog',
    components: { Accordion, AccordionTab, Dialog, Editor, Message },
    props: { visible: { type: Boolean } },
    emits: ['close', 'sendMail'],
    data() {
        return {
            documentExecutionMailDialogDescriptor,
            mail: {} as iMail,
            mailToDirty: false
        }
    },
    computed: {
        ccHelp(): string {
            return (this.mail.CC?.length ?? '0') + ' / ' + this.documentExecutionMailDialogDescriptor.ccMaxLength
        },
        objectHelp(): string {
            return (this.mail.OBJECT?.length ?? '0') + ' / ' + this.documentExecutionMailDialogDescriptor.objectMaxLength
        },
        saveButtonDisabled(): boolean {
            return !this.mail.TO || this.mail.TO.length === 0
        }
    },
    created() {},
    methods: {
        closeDialog() {
            this.mail = {} as iMail
            this.$emit('close')
        },
        save() {
            this.$emit('sendMail', this.mail)
        }
    }
})
